// ### Function converts string to number, if necessary

export const getNumberFromString = (input: string | number) => {
    if (typeof input === 'number') {
        return input;
    }
    return parseInt(input.toString().replace(/ /g, '').trim());
};
